// Grouped client for EntityOwnedModel operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Form } from '../models/Form';
import { FormSerializer } from '../serializers/FormSerializer';

/**
 * HTTP client for EntityOwnedModel operations
 *
 * Client for EntityOwnedModel operations
 */
export class EntityOwnedModelClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getFormForEntityOwnedModel(formName: string, objectId: string, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/EntityOwnedModel({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeEntityOwnedModel(formName: string, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/EntityOwnedModel/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

}
